import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Loader } from '@getro/rombo';

export const OutreachSetupStep = ({ isLoading, error }) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {isLoading && !error && (
      <Flex
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          zIndex: 10,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Flex flexDirection="column" alignItems="center" gap={3}>
          <Loader />
          <Text fontSize="14px" color="text.subtle" mt="16px">
            Loading outreach setup...
          </Text>
        </Flex>
      </Flex>
    )}

    {error && (
      <Flex
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          zIndex: 10,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Flex flexDirection="column" alignItems="center" gap={2}>
          <Text fontSize="16px" fontWeight="600" color="text.dark">
            Error loading outreach setup
          </Text>
          <Text fontSize="14px" color="text.subtle">
            {error.message || 'Something went wrong. Please try again.'}
          </Text>
        </Flex>
      </Flex>
    )}

    {/* Findem widget container */}
    <Box
      id="findem-widget-modal"
      sx={{
        width: '100%',
        height: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        '& #findem-widget-iframe': {
          width: '100% !important',
          height: 'calc(100vh - 64px) !important',
        },
      }}
    />
  </Box>
);

OutreachSetupStep.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};

OutreachSetupStep.defaultProps = {
  isLoading: false,
  error: null,
};
